import styled from 'styled-components';

import { TextField } from '@material-ui/core';
import AutoComplete from '@material-ui/lab/Autocomplete';
import {MuiFormLabelFilledColorByCurrentApp} from '../../utils/get-app-env';

export const StyledAutoComplete = styled(AutoComplete)`
  width: 90%;

  
  & .MuiInputBase-input {
    color: ${(MuiFormLabelFilledColorByCurrentApp())};
  }
`;

export const StyledTextField = styled(TextField)`
  margin-left: 20px;
`;
